import { createFileRoute } from '@tanstack/react-router'

import { PaymentMethodsProductPage } from '#/modules/intake/payment-methods-product-page'

export const Route = createFileRoute('/_shell/payment-methods')({
  component: PaymentMethodsProductPage,
})
